const LEVEL_RANK = {
  viewer: 1,
  editor: 2,
};

/** Level the user has on a catalog node from `myAccess`; null if not visible or a group. */
export function accessLevelOf(accessNodes, nodeId) {
  const node = accessNodes.find((entry) => entry.id === nodeId);
  return node?.level ?? null;
}

/** Editor covers viewer; no level covers nothing. */
export function coversAccessLevel(actualLevel, requiredLevel) {
  return Boolean(actualLevel) && LEVEL_RANK[actualLevel] >= LEVEL_RANK[requiredLevel];
}
